module.exports = __webpack_public_path__ + "img/imgexchangebtgay.bcecda35.png";